import { SearchResultType } from "core/codegen/types";
export var isProgramSearchResultItem = function (result) {
    return result.type === SearchResultType.Program;
};
